<div class="font-bold mb-3" i18n>
  When you have more than one Network Authentication Application (NAA; USIM & ISIM, multi-USIM, or multi-ISIM), you can reference the AKA
  parameters from another NAA or define separate AKA parameters independently. Typically, 3G/4G LTE/5G network deploys USIM and ISIM
  together.
</div>
<div class="font-bold mb-3" i18n>Do you want to map USIM and ISIM for the AKA parameters?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAparameters"
          inputId="networkAuthentication.mapUSIMandISIMforAKAparameters#1"
          value="1"
          [disabled]="true"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAparameters"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAparameters#1" i18n>Yes</label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAparameters"
          inputId="networkAuthentication.mapUSIMandISIMforAKAparameters#0"
          value="0"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAparameters"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAparameters#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
